var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import "./public-post-page.sass";
import PageBuilder from "./page-builder";
const getData = () => __async(null, null, function* () {
  const pathname = window.location.pathname;
  const slugName = pathname.split("/")[2];
  const postId = pathname.split("/")[3];
  const urls = [
    `${window._env_.API_URL}/v2/tints/${slugName}/posts?filter[id]=${postId}`,
    `${window._env_.API_URL}/v2/tints/${slugName}?include=social_feeds,personalizations`
  ];
  const requests = urls.map((url) => fetch(url));
  const responses = yield Promise.all(requests);
  const promises = responses.map((response) => response.json());
  return yield Promise.all(promises).then((res) => {
    return {
      posts: res[0].data[0],
      personalizations: res[1].included[0]
    };
  });
});
const init = () => __async(null, null, function* () {
  let data = {};
  yield getData().then((response) => {
    data = response;
  }).catch(() => {
    data.hasError = true;
  });
  const container = document.querySelector("#tint-public-posts-page");
  yield new PageBuilder().render(container, data);
});
init();
